
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.184 19.37h4.09s.05.08.08.14c2.03 3.55 3.09 5.38 3.63 6.34-1.6 2.83-6.03 10.67-6.04 10.69-.04.06-.06.11-.09.15h-4.07l5.58-9.85.5-.94-.45-.93-.03-.06-.03-.06-3.16-5.47m-1.91-2c-.37 0-.68.13-.83.38-.16.26-.14.6.03.94l4.13 7.15v.03l-6.49 11.45c-.17.34-.16.68 0 .94.16.25.43.42.8.42h6.11c.91 0 1.35-.62 1.67-1.18 0 0 6.35-11.23 6.59-11.66-.03-.04-4.2-7.32-4.2-7.32-.3-.54-.76-1.15-1.7-1.15h-6.11zM45.234 11l-12.56 22.21-.71 1.08.72 1.05 7.67 14.02h-4.13l-.07-.12-8.15-14.95c2.56-4.53 13.05-23.14 13.05-23.15.03-.06.06-.1.08-.14h4.1zm1.88-2h-6.17c-.91 0-1.31.58-1.64 1.16 0 0-13.16 23.34-13.59 24.1.02.04 8.68 15.92 8.68 15.92.3.54.77 1.16 1.71 1.16h6.1c.37 0 .66-.14.81-.39.16-.26.16-.61-.01-.94l-8.61-15.73v-.04l13.52-23.91c.17-.34.17-.68.01-.94-.16-.25-.44-.39-.81-.39z","fill":"currentColor"}})])
          )
        }
      }
    